import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Copy = ({
  size,
  type,
  theme,
  className,
  dataTestId = "copy-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.81846 0.345703C6.56662 0.345703 5.5518 1.36052 5.5518 2.61237V4.98503H3.17914C1.9273 4.98503 0.912476 5.99985 0.912476 7.25169V13.3909C0.912476 14.6428 1.92729 15.6576 3.17914 15.6576H8.17567C9.42751 15.6576 10.4423 14.6428 10.4423 13.3909V11.0183H12.815C14.0668 11.0183 15.0817 10.0034 15.0817 8.7516V2.61237C15.0817 1.36053 14.0668 0.345703 12.815 0.345703H7.81846ZM10.4423 9.68493H12.815C13.3305 9.68493 13.7483 9.26706 13.7483 8.7516V2.61237C13.7483 2.0969 13.3305 1.67904 12.815 1.67904H7.81846C7.303 1.67904 6.88513 2.0969 6.88513 2.61237V4.98503H8.17567C9.42752 4.98503 10.4423 5.99985 10.4423 7.25169V9.68493ZM6.88513 6.31836H8.17567C8.69113 6.31836 9.109 6.73623 9.109 7.25169V9.68493H7.81846C7.303 9.68493 6.88513 9.26706 6.88513 8.7516V6.31836ZM5.5518 6.31836V8.7516C5.5518 10.0034 6.56662 11.0183 7.81846 11.0183H9.109V13.3909C9.109 13.9064 8.69113 14.3243 8.17567 14.3243H3.17914C2.66368 14.3243 2.24581 13.9064 2.24581 13.3909V7.25169C2.24581 6.73623 2.66368 6.31836 3.17914 6.31836H5.5518Z"
    />
  </SVGIcon>
);
